module.exports = __webpack_public_path__ + "static/media/item_2_6.045c5d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_6.png
// module id = 113
// module chunks = 0